<ng-template #customSnackBar let-text="text">
  <div class="alert-snack-bar" role="alert" >
    <div class="">{{notification.title}}</div>
      <div class="">{{notification.body}}</div>
  </div>
</ng-template>
